// Serve the official browser bundles as local assets; do not execute these packages during SSR.
export async function preparePickupMapModules(
  api: Pick<typeof ymaps3, 'ready' | 'import'>,
  urls: { clusterer: string; controls: string },
) {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  try {
    await Promise.race([
      loadModules(api, urls),
      new Promise<never>((_, reject) => {
        timeout = setTimeout(() => reject(new Error('Yandex Maps modules loading timed out')), 15000);
      }),
    ]);
  } finally {
    clearTimeout(timeout);
  }
}

async function loadModules(
  api: Pick<typeof ymaps3, 'ready' | 'import'>,
  urls: { clusterer: string; controls: string },
) {
  await api.ready;
  api.import.registerCdn('{path}?package={package}&version={version}', {
    '@yandex/ymaps3-clusterer': { version: '0.0.12', path: urls.clusterer },
    '@yandex/ymaps3-default-ui-theme': { version: '0.0.24', path: urls.controls },
  });
  await Promise.all([api.import('@yandex/ymaps3-clusterer'), api.import('@yandex/ymaps3-default-ui-theme')]);
}
